{
  "app.title": "Employés",
  "app.logout": "Déconnexion",
  "app.language": "Français",
  "app.settings": "Paramètres",
  "settings.title": "Synchronisation",
  "settings.send_to_all_apps_users": "Envoyer les utilisateurs à tout le monde",
  "settings.send_to_all_apps_missions": "Envoyer les missions à tout le monde",
  "settings.sync_with_iam": "Synchroniser avec l'IAM",
  "settings.sync_with_erp": "Synchroniser avec l'ERP",
  "settings.sync_missions": "Synchroniser les missions avec Salesforce",
  "settings.send_to_all_apps_users.description": "Publie tous les utilisateurs enregistrés en base vers les applications à l'écoute, pour qu'elles mettent à jour leur copie de l'annuaire des employés.",
  "settings.send_to_all_apps_missions.description": "Publie toutes les missions enregistrées en base vers les applications à l'écoute, pour qu'elles mettent à jour leur copie des missions.",
  "settings.sync_with_iam.description": "Associe chaque utilisateur à son compte Keycloak via son email, puis met à jour son identifiant IAM et ses rôles.",
  "settings.sync_with_erp.description": "Récupère les employés depuis SAP : met à jour les postes et départements, crée les nouveaux utilisateurs, met à jour ceux qui ont changé et désactive ceux qui ne sont plus dans SAP. Les changements sont publiés vers les applications à l'écoute.",
  "settings.sync_missions.description": "Récupère les missions depuis Salesforce, les crée ou les met à jour en base et publie les changements vers les applications à l'écoute.",
  "settings.sync_missing_avatars": "Synchroniser les avatars manquants",
  "settings.sync_missing_avatars.description": "Cherche une photo de profil dans le dossier Google Drive pour chaque utilisateur qui n'a pas encore d'avatar.",
  "settings.button.run": "Lancer",
  "settings.button.running": "En cours...",
  "settings.button.stop": "Arrêter",
  "settings.button.cancel": "Annuler",
  "settings.stop.confirm.title": "Arrêter cette synchronisation ?",
  "settings.stop.confirm.description": "Elle sera marquée en échec et pourra être relancée.",
  "settings.last_run": "Dernière exécution",
  "settings.last_success": "Dernier succès :",
  "settings.never": "jamais",
  "settings.never_run": "Jamais exécutée",
  "settings.status.running": "En cours",
  "settings.status.success": "Succès",
  "settings.status.failure": "Échec",
  "settings.trigger.manual": "Manuel",
  "settings.trigger.service_account": "Compte de service",
  "settings.trigger.scheduled": "Automatique",
  "settings.history.title": "Historique",
  "settings.history.action": "Action",
  "settings.history.trigger": "Déclencheur",
  "settings.history.who": "Par",
  "settings.history.started_at": "Démarrée",
  "settings.history.duration": "Durée",
  "settings.history.status": "Statut",
  "info.sync.started.title": "Démarrée",
  "info.sync.started.description": "Le résultat sera affiché sur la carte.",
  "warning.sync.already_running.title": "Déjà en cours",
  "warning.sync.already_running.description": "Déjà en cours, lancée par {author} à {time}",
  "info.sync.stopped.title": "Arrêtée",
  "info.sync.stopped.description": "La synchronisation peut être relancée.",
  "info.sync.already_finished.title": "Déjà terminée",
  "info.sync.already_finished.description": "Cette exécution était déjà terminée.",
  "table.reset_filters": "Réinitialiser les filtres",
  "table.search_name": "Rechercher par prénom ou nom",
  "table.department_filter": "Tous les départements",
  "table.showing_inactive_user_filter": "Utilisateurs inactifs",
  "table.id": "SAP ID",
  "table.first_name": "Prénom",
  "table.last_name": "Nom",
  "table.starting_date": "Date de début",
  "table.last_modification": "Dernière modification (SAP)",
  "table.job": "Poste",
  "table.department": "Département",
  "table.roles": "Roles",
  "table.active": "Actif",
  "table.inactive": "Inactif",
  "table.role.other": "autres",
  "table.role.uma_authorization": "Autorisation UMA",
  "job_title.consultant": "Consultant",
  "job_title.commercial": "Commercial",
  "job_title.direction": "Direction",
  "job_title.staff": "Staff",
  "job_title.intern": "Stagiaire",
  "job_title.pro_contract": "Contrat Professionel",
  "collaborator.seniority": "Ancienneté",
  "collaborator.contract_period": "Résumé des contrats",
  "collaborator.contract": "Contrat",
  "collaborator.avatar.upload": "Mettre à jour l'avatar",
  "collaborator.avatar.delete": "Supprimer l'avatar",
  "time.year": "an",
  "time.month": "mois",
  "time.day": "jour",
  "time.first_day": "Premier jour 💖",
  "vocab.and": "et",
  "language.title": "Erreur",
  "language.description": "Le switch de langue n'a pas été trouvé",
  "success.title": "Succès",
  "success.avatar.upload.description": "L'avatar a été mis à jour avec succès",
  "success.avatar.delete.description": "L'avatar a été supprimé avec succès",
  "error.title": "Erreur",
  "error.back_to_home": "Retour à l'accueil",
  "error.sync.description": "Syncronisation échouée",
  "error.sync.stop.description": "Impossible d'arrêter la synchronisation",
  "error.not_found.title": "Erreur 404",
  "error.not_found.sub_title": "La page que vous cherchez n'existe pas.",
  "error.forbidden.title": "Erreur 403",
  "error.forbidden.sub_title": "Vous n'avez pas les droits pour accéder à cette page.",
  "error.users.description": "Une erreur est survenue lors du chargement des utilisateurs",
  "error.missions.description": "Une erreur est survenue lors du chargement des missions",
  "app.missions": "Missions",
  "table.search_mission": "Recherche par email utilisateur ou client",
  "table.mission_name": "Mission",
  "table.yes": "Oui",
  "table.no": "Non",
  "table.client_name": "Client",
  "table.takima_user_email": "Email Takima",
  "table.start_date": "Date de début",
  "table.end_date": "Date de fin",
  "table.mission_ended": "Terminée",
  "table.showing_ended_mission_filter": "Missions terminées uniquement",
  "table.search_client_name": "Recherche par nom de client",
  "table.search_takima_email": "Recherche par email Takima",
  "error.user.description": "Une erreur est survenue lors du chargement de l'utilisateur ({userId})",
  "error.avatar.upload.description": "Erreur lors de la mise à jour de l'avatar",
  "error.avatar.delete.description": "Erreur lors de la suppression de l'avatar",
  "error.avatar.type.title": "Type de fichier invalide",
  "error.avatar.type.description": "Le type de fichier doit être un JPEG ou PNG !",
  "error.avatar.size.title": "Taille de fichier invalide",
  "error.avatar.size.description": "Fichier trop gros. La taille du fichier ne doit pas dépasser 1 Mo.",
  "app.back": "Retour",
  "users.eyebrow": "Annuaire",
  "users.empty": "Aucun collaborateur ne correspond à ces filtres",
  "users.total": "{total, plural, one {# collaborateur} other {# collaborateurs}}",
  "users.filter.all": "Tous",
  "users.filter.active": "Actifs",
  "users.last_erp_sync": "Dernière synchronisation ERP",
  "users.manage_sync": "Gérer",
  "missions.eyebrow": "Staffing",
  "settings.eyebrow": "Administration",
  "collaborator.avatar.edit": "Changer l'avatar",
  "collaborator.information": "Informations",
  "collaborator.contract.current": "En cours",
  "collaborator.contract.open_ended": "Aujourd'hui",
  "collaborator.missions.empty": "Aucune mission pour le moment",
  "collaborator.missions.ongoing": "En cours",
  "collaborator.missions.prolongations": "{count, plural, one {# prolongation} other {# prolongations}}",
  "error.user.not_found": "Collaborateur introuvable",
  "table.on_bench": "En interne",
  "collaborator.status": "Statut",
  "table.takima_user": "Collaborateur",
  "table.search_takima_user": "Rechercher un collaborateur (nom ou email)"
}
